import React, {useEffect} from 'react';
import {ErrorContext} from './contexts';


let globalSetErrors: (value: (((prevState: never[]) => never[]) | never[])) => void = () => {};
let globalGetErrors = (): never => {};

function ErrorProvider({children}: {children: React.ReactNode}) {
    const [errors, setErrors] = React.useState([])

    useEffect(() => {
        globalSetErrors = setErrors
        globalGetErrors = () => errors
    }, []);
    return <ErrorContext.Provider value={{errors, setErrors}}>
        {children}
    </ErrorContext.Provider>
}

export {ErrorContext, ErrorProvider, globalGetErrors, globalSetErrors}
